import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ApiLink from 'API';
import SimpleBackdrop from 'ui-component/SimpleBackdrop';

export default function SetComing({ Open, setOpen, ReloadData, SelectedData, setAlertBox }) {
    const [openBackdrop, setopenBackdrop] = React.useState(false);
    const navigate = useNavigate();
    const handleClose = () => {
        setOpen(false);
    };
    const SubmitDelete = () => {
        if (SelectedData?._id !== '') {
            setopenBackdrop(true);
            axios
                .put(
                    ApiLink + '/api/requestproduct/management/setstatus/' + SelectedData._id,
                    { status: '1' },
                    {
                        withCredentials: true,
                        headers: {
                            token: localStorage.getItem('token')
                        }
                    }
                )
                .then((res) => {
                    // console.log(res.data);

                    setAlertBox({
                        open: true,
                        message: 'Reject success',
                        severity: 'success'
                    });

                    //   Clearfrom();
                    ReloadData('');
                    setOpen(false);
                    setopenBackdrop(false);
                    //  LoadProduct("");
                })
                .catch((error) => {
                    console.log(error);
                    try {
                        if (error.response.status === 400 || error.response.status === 500) {
                            setAlertBox({
                                open: true,
                                message: error.response.data.msg,
                                severity: 'error'
                            });
                            //  LoadProduct("");
                        } else if (error.response.status === 401) {
                            //got to login and clear token
                            localStorage.clear();
                            navigate(0);
                        } else {
                            setAlertBox({
                                open: true,
                                message: error.response.statusText,
                                severity: 'error'
                            });
                            setopenBackdrop(false);
                            //  LoadProduct("");

                            // console.log(error.response.statusText);
                        }
                    } catch (error) {
                        setAlertBox({ open: true, message: error, severity: 'error' });
                        //  LoadProduct("");
                        setopenBackdrop(false);
                    }
                });
        } else {
            setAlertBox({
                open: true,
                message: 'Invoice has problem',
                severity: 'error'
            });
        }
    };
    return (
        <div>
            <SimpleBackdrop open={openBackdrop} />
            <Dialog open={Open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {'Are your sure for set status to Comming  ? ID: ' + SelectedData.invoiceRequest + ' ?'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">Set status for mark this order coming to stock</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={handleClose}>
                        Disagree
                    </Button>
                    <Button color="primary" startIcon={<LocalShippingIcon />} onClick={SubmitDelete} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
